angular.module("Main").controller("OnlineSalesPrivacyTermsDialogController", ["BookingService", function (BookingService) {
    var vm = this;

    BookingService.getPrivacyTextOnlineSales().then(function (data) {
        vm.privacytermsTextOnlineSales = data.text.PrivacyPolicy;
    })
}]);